<template>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7 15C5.89543 15 5 14.1046 5 13L5 3C5 1.89543 5.89543 1 7 1L10 1L15 6.00003L15 13C15 14.1046 14.1046 15 13 15L7 15Z" stroke="#008DD2" stroke-width="2" stroke-linejoin="round"/>
		<path d="M15 6H10V1" stroke="#008DD2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>